import script from "./unbindDevice.vue?vue&type=script&lang=ts&setup=true"
export * from "./unbindDevice.vue?vue&type=script&lang=ts&setup=true"

import "./unbindDevice.vue?vue&type=style&index=0&id=0da23abb&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da23abb"]])

export default __exports__